/**
 * Widget Configurator Sample
 * The input and output of the configurator is the profile of its corressponding
 * widget.
 * @author zyz
 * @created 03/22/2016
 */

require('./index.less');
require('./upload');

// Class, jQuery, Enhancer are global objects that you can use them anywhere
// referer to #doc...
//import List from './list';

require('./index.less');
//var locale = require('./i18n');


Enhancer.registerWidget({
    /**
     * Widget Constructing Function
     * @param profile {Object} The widget profile which is configurated by
     *   widget configurator.
     * @param zContext {Object} Current context which contains the dependent
     *    variable values of this widget.
     */
    construct(profile, zContext) {
        var self = this;
        var $container = self.getContainer();
        $container.uploadFile({
            url:"/file/upload",
        });

        return $container;
    },
    /**
     * getData {Function} Each widget instance should contain the data of variables
     *   which are declared by widget-configurator when the widget is bound in this
     *   window and the `getSupportedVariables` method of widget-configurator is
     *   called. It is recommend to return default data which are specified by app
     *   developer in widget-configurator maybe so that there are available data
     *   used by other depended window when this widget is initilized as primary.
     * @return {Object} The data of variables.
     */
    getData() {
        return {
            "variableName": "value",
            "name": "tj"
        };
    },
    /**
     * isReady {Function} The Enhancer will call this method to check if the data of
     *   this widget is available so that to controll next action to response the event.
     * @return {Boolean} whether the data is ready or available.
     */
    isReady() {
        var isReady = true;
        if (!isReady) {
            // Do sth to show user this widget is not ready.
        }
        return isReady;
    },
    /**
     * affected {Function} This method will be called when some event is triggered
     *   and this widget should be affected following the operating flow diagram.
     * @param zContext {Object} Current context which contains the dependent
     *    variable values of this widget.
     */
    affected(zContext) {
    }
});


// WEBPACK FOOTER //
// ./src/index.js